import React, { useEffect, useState } from "react";
import { useClients } from "@/context/ClientContext";
import api from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Sparkles, TrendingUp, TrendingDown, ArrowRightLeft, Info } from "lucide-react";

const ICONS = { winner: TrendingUp, loser: TrendingDown, transfer: ArrowRightLeft };
const TONE = {
  winner: "border-emerald-200 bg-emerald-50", loser: "border-amber-200 bg-amber-50", transfer: "border-sky-200 bg-sky-50",
};

export default function Performance() {
  const { current } = useClients();
  const [sug, setSug] = useState([]);
  useEffect(() => { if (current) api.get(`/performance/suggestions?client_id=${current.id}`).then(({ data }) => setSug(data)); }, [current]);

  if (!current) return <div className="text-slate-400">Kein Mandant ausgewählt.</div>;

  return (
    <div>
      <PageHeader overline={current.name} title="Performance-Optimierung" subtitle="Datenbasierte Vorschläge – Gewinner skalieren, Schwaches pausieren. Jede Aktion mit Sicherheitsstufe (Vorschlag → Bestätigung)." />
      {sug.length === 0 ? (
        <EmptyState icon={Sparkles} title="Noch keine Vorschläge" hint="Sobald genügend Performance-Daten vorliegen, generiert das System Optimierungsvorschläge." />
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {sug.map((s) => {
            const Icon = ICONS[s.type] || Info;
            return (
              <Card key={s.id} data-testid={`suggestion-${s.type}`} className={`p-5 rounded-md shadow-none border ${TONE[s.type] || "border-slate-200 bg-white"}`}>
                <div className="flex items-start gap-3">
                  <div className="h-9 w-9 rounded-md bg-white border border-slate-200 flex items-center justify-center shrink-0"><Icon size={17} /></div>
                  <div className="flex-1">
                    <div className="font-semibold text-slate-800">{s.title}</div>
                    <div className="text-sm text-slate-500 mt-1 flex items-start gap-1"><Info size={13} className="mt-0.5 shrink-0" /><span><b>Begründung:</b> {s.reason}</span></div>
                    <div className="text-sm text-slate-700 mt-2 bg-white/60 rounded-sm p-2 border border-slate-200"><b>Empfehlung:</b> {s.recommendation}</div>
                    <div className="flex gap-2 mt-3">
                      <button data-testid={`suggestion-apply-${s.id}`} className="text-xs font-semibold px-3 py-1.5 rounded-full bg-[#0A0A0A] text-white hover:bg-[#212529]">Vorschlag übernehmen</button>
                      <button className="text-xs font-semibold px-3 py-1.5 rounded-full border border-slate-300 hover:bg-white">Ignorieren</button>
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
